import { Error404 } from "views";
import custRoutes from "modules/cust/routes";
import baRoutes from "modules/ba/routes";
import lnRoutes from "modules/ln/routes";
import dpRoutes from "modules/dp/routes";
import paRoutes from "modules/pa/routes";
import rptRoutes from "modules/rpt/routes";
import Dashboard from "modules/dashboard/Dashboard";
import empRoutes from "modules/emp/routes";
import errorRoutes from "modules/error/routes";
import feeRoutes from "modules/fee/routes";

const routes = [
  custRoutes,
  empRoutes,
  baRoutes,
  lnRoutes,
  dpRoutes,
  paRoutes,
  feeRoutes,
  rptRoutes,
  errorRoutes,
  {
    path: "/",
    element: <Dashboard />,
    index: true,
  },
  {
    path: "*",
    element: <Error404 />,
  },
];

export default routes;
